import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { daysNames } from '../../../utils/weekDays';
import Classes from '../ProfileSidebar.scss';

const OpeningHours = ({ openingHours }: { openingHours: any }) => {
  const i18n = useI18nContext();

  return (
    <div className={Classes.openingHoursPopupWrap}>
      {Object.keys(openingHours)
        .sort((a, b) => daysNames[a as keyof typeof daysNames] - daysNames[b as keyof typeof daysNames])
        .map((key) => (
          <div className={Classes['openingHoursPopupWrap-item']} key={key}>
            <span className={Classes['openingHoursPopupWrap-day']}>
              {i18n.t(`sellerProfile.businessHours.${key}`)}:
            </span>
            {!openingHours[key].closed ? (
              <span className={Classes['openingHoursPopupWrap-time']}>
                {openingHours[key].openFrom} - {openingHours[key].openTill}
              </span>
            ) : (
              <span className={Classes['openingHoursPopupWrap-time']}>
                {i18n.t('sellerProfile.businessHours.closed')}
              </span>
            )}
          </div>
        ))}
    </div>
  );
};

export default OpeningHours;
